class htmlEncode {
  static encode(text) {
    return text.replace(/</gi, "&lt;").replace(/>/gi, "&gt;").replace(/"/gi, "&quot;");
  }
}
module.exports = htmlEncode;
